import { defineStore } from "pinia";

export const useAddressStore = defineStore('address', {
    state: () => ({
        address: {},
        addresses: [],
    }),
    actions: {
        setAddress(address) {
            this.address = address
        },
        setAddresses(addresses) {
            this.addresses = addresses
        },
        addAddress(address) {
            this.addresses.unshift(address)
        },
        updateAddress(address) {
            let index = this.addresses.findIndex(cl => cl.id === address.id)
            this.addresses.splice(index, 1, address)
        },
        deleteAddress(address) {
            let index = this.addresses.findIndex(cl => cl.id === address.id)
            this.addresses.splice(index, 1)
        },
    },
});